import PageBanner, { PageBannerProps } from '@/components/_rebrand/PageBanner';
import { parseHtml } from '@/lib/parse-html';
import Image from 'next/image';

const displayProps = {
  title: '',
  description: '',
  descriptionTwo: '',
  bannerImage: null,
  showNewTag: false,
} as PageBannerProps;


type FeatureImageFromCraft = {
  url: string;
  title: string;
  width: number;
  height: number;
}

type ModuleProductFeatureHighlight = {
  backgroundColor: string,
  featuredImage: FeatureImageFromCraft,
  headline: string,
  description: string,
  hideSection: boolean,
  showNewLabel: boolean,
}

const formImageTag = (image: FeatureImageFromCraft): PageBannerProps['bannerImage'] => {
  const data = Array.isArray(image) ? image[0] : image;

  /*
   * When entries are cloned, its possible for the image to exist but have empty fields
   * Since this component can be hidden in the CMS, it shoulnd't error out if the image is missing
   */
  return data?.url ? <Image src={data.url} width={data.width} height={data.height} alt={data.title} className="w-[90%] md:w-full rounded-tl-[16px] md:rounded-tl-0 md:rounded-tr-[16px]" /> : null;
}

const setDynamicDisplayPropAttributes = (feature: ModuleProductFeatureHighlight) => {
  displayProps.title = feature.headline;
  displayProps.description = feature.description ? parseHtml(feature.description) : '';
  displayProps.bannerImage = formImageTag(feature.featuredImage);
  displayProps.showNewTag = feature.showNewLabel;
};

const FeatureHighlight = ({ entry }) => {
  const data = Array.isArray(entry?.moduleProductFeatureHighlight)
    ? entry.moduleProductFeatureHighlight[0]
    : entry?.moduleProductFeatureHighlight;

  setDynamicDisplayPropAttributes(data);

  displayProps.backgroundColor = (data.backgroundColor == 'themeColor') ? entry.moduleProductTheme[0].color : data.backgroundColor;

  if (data.hideSection) {
    return null;
  }

  return (
    <PageBanner {...displayProps} />
  );
};

export default FeatureHighlight;
